module.exports = __webpack_public_path__ + "static/media/Back.fe11ff40.svg";